import { API } from "../../main.js";

const state = {};

const getters = {};

const mutations = {};

const actions = {
  GET_ALL_IMPORTS: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      API.import.getAll(
        data.timestamp,
        data.queryParams,
        data.filters,
        result => {
          resolve(result);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  GET_IMPORT_BY_UUID: ({ commit }, uuid) => {
    return new Promise((resolve, reject) => {
      API.import.getByUUID(
        uuid,
        result => {
          resolve(result);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  CREATE_IMPORT: ({ commit }, { endpoint, data }) => {
    return new Promise((resolve, reject) => {
      API.import.byEndpoint(
        endpoint,
        data,
        result => {
          resolve(result);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  CREATE_IMPORT_VALIDATION: ({ commit }, { endpoint, data }) => {
    return new Promise((resolve, reject) => {
      API.import.validationByEndpoint(
        endpoint,
        data,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  GET_IMPORT_CONFLICTS: ({ commit }, { queryParams, endpoint, uuid }) => {
    return new Promise((resolve, reject) => {
      API.import.getConflicts(
        queryParams,
        endpoint,
        uuid,
        result => {
          resolve(result.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  GET_IMPORT_NEW_OBJECTS: ({ commit }, { endpoint, uuid }) => {
    return new Promise((resolve, reject) => {
      API.import.getNewObjects(
        endpoint,
        uuid,
        result => {
          resolve(result);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  GET_IMPORT_OBJECTS_PAGINATED: ({ commit }, url) => {
    return new Promise((resolve, reject) => {
      API.import.getImportObjectsPaginated(
        url,
        result => {
          resolve(result);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  GET_MAPPER_TEMPLATES_BY_LAYER({ commit }, layer) {
    return new Promise((resolve, reject) => {
      API.import.getMapperTemplatesByLayer(
        layer,
        result => {
          resolve(result.data.data[0].templates);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  fetchImportTemplates({ commit }, params) {
    return new Promise((resolve, reject) => {
      API.import.getMapperTemplates(
        params,
        result => {
          resolve(result.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  fetchAllImportTemplates({ commit }) {
    return new Promise((resolve, reject) => {
      API.import.getAllMapperTemplates(
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  fetchTemplateByID({ commit }, { id, append = null }) {
    return new Promise((resolve, reject) => {
      API.import.getMapperTemplateById(
        id,
        append,
        result => {
          resolve(result.data.data[0]);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  addImportTemplate({ commit }, template) {
    return new Promise((resolve, reject) => {
      API.import.createImportTemplate(
        template,
        result => {
          resolve(result);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  editImportTemplateById({ commit }, { id, data }) {
    return new Promise((resolve, reject) => {
      API.import.editImportTemplate(
        id,
        data,
        result => {
          resolve(result);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  deleteImportTemplate({ commit }, id) {
    return new Promise((resolve, reject) => {
      API.import.deleteMapperTemplateByID(
        id,
        result => {
          resolve(result);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  cancelImport({ commit }, uuid) {
    return new Promise((resolve, reject) => {
      API.import.cancelImport(
        uuid,
        result => {
          resolve(result);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  deleteImport({ commit }, uuid) {
    return new Promise((resolve, reject) => {
      API.import.deleteByUUID(
        uuid,
        result => {
          resolve(result);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  cancelImportInProgress({ commit }, uuid) {
    return new Promise((resolve, reject) => {
      API.import.cancelImportInProgress(
        uuid,
        result => {
          resolve(result.data.export);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  fetchTemplatesTypes() {
    return new Promise((resolve, reject) => {
      API.import.getTemplatesTypes(
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  fetchKeysFromFile({ commit }, data) {
    return new Promise((resolve, reject) => {
      API.import.getKeysFromFile(
        data,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  }
};

export default { state, getters, actions, mutations };



// WEBPACK FOOTER //
// ./src/store/modules/import.js